module.exports = __webpack_public_path__ + "img/13.66e840ec.jpg";